import {
  createStyles, Grid, makeStyles, Theme, TextField,
} from '@material-ui/core';
import React from 'react';
import { useFormContext, ControllerRenderProps, Controller } from 'react-hook-form';

interface IFormElementWithTwoInput {
    labelInput: string;
    placeHolderInput1?: string;
    placeHolderInput2?: string;
    nameInput1: string;
    nameInput2: string;
    autoFocus1?: boolean;
    autoFocus2?: boolean;
}

const FormElementWithTwoInput : React.FC<IFormElementWithTwoInput> = ({
  labelInput,
  placeHolderInput1,
  placeHolderInput2,
  nameInput1,
  nameInput2,
  autoFocus1 = false,
  autoFocus2 = false,
}) => {
  const { control, errors } = useFormContext();
  const classes = useStyles();

  return (
    <Grid container={true} spacing={2} className={classes.formElementControl}>
      <Grid item={true} md={4} xs={12}>
        <div className={classes.formLabelInput}>
          <p>
            <span>必須</span>
            {labelInput}
          </p>
        </div>
      </Grid>
      <Grid item={true} md={4} xs={5}>
        <Controller
          name={nameInput1}
          control={control}
          render={(
            { ref, ...rest }: ControllerRenderProps,
          ) => (
            <TextField
              {...rest}
              inputRef={ref}
              fullWidth={true}
              className={classes.formInput}
              placeholder={placeHolderInput1}
              label={placeHolderInput1}
              variant="outlined"
              margin="normal"
              error={!!errors[`${nameInput1}`]}
              helperText={errors[`${nameInput1}`]?.message || ''}
              autoFocus={autoFocus1}
            />
          )}
        />
      </Grid>
      <Grid item={true} md={4} xs={5}>
        <Controller
          name={nameInput2}
          control={control}
          render={(
            { ref, ...rest }: ControllerRenderProps,
          ) => (
            <TextField
              {...rest}
              inputRef={ref}
              fullWidth={true}
              className={classes.formInput}
              placeholder={placeHolderInput2}
              label={placeHolderInput2}
              variant="outlined"
              margin="normal"
              error={!!errors[`${nameInput2}`]}
              helperText={errors[`${nameInput2}`]?.message || ''}
              autoFocus={autoFocus2}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};


const useStyles = makeStyles((theme: Theme) => createStyles({
  formElementControl: {
    marginBottom: '29px',
    marginLeft: '10px',
    width: 'calc(100% - 55px)',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
      width: '100%',
    },
  },
  formLabelInput: {
    backgroundColor: '#EBEBEB',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: '37px',
    },
    '& p': {
      fontSize: '18px',
      lineHeight: '26px',
      color: '#1a1a1a',
      letterSpacing: '0.8px',
      fontWeight: 600,
      textAlign: 'center',
      paddingLeft: '12px',
      '& span': {
        fontSize: '14px',
        lineHeight: '21px',
        color: '#ffffff',
        backgroundColor: '#d0111b',
        marginRight: '0.3em',
      },
    },
  },
  formInput: {
    // height: '60px',
    margin: '0',
    borderRadius: '5px',
    fontSize: '18px',
    lineHeight: '26px',
    color: '#6F7878',
    letterSpacing: '0.8px',
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      height: '50px',
    },
  },

}));
export default FormElementWithTwoInput;
